<template>
  <div>
    <!-- 两个大按钮选择页面 -->
    <el-row v-if="goodCashierInfo.componentShow == 'goodCashierInfo'" :gutter="20">
      <el-col :span="24">
        <el-card>
          <div style="display: flex; justify-content: center; align-items: center; min-height: 60vh;">
            <div style="display: flex; gap: 50px;">
              <el-button
                type="primary"
                style="width: 300px; height: 200px; font-size: 2rem; font-weight: bold;"
                @click="goToGoodsCashier"
              >
                <div style="display: flex; flex-direction: column; align-items: center; gap: 20px;">
                  <i class="el-icon-goods" style="font-size: 4rem;"></i>
                  <span>收银台</span>
                </div>
              </el-button>
              <el-button
                type="success"
                style="width: 300px; height: 200px; font-size: 2rem; font-weight: bold;"
                @click="showRestaurantMessage"
              >
                <div style="display: flex; flex-direction: column; align-items: center; gap: 20px;">
                  <i class="el-icon-food" style="font-size: 4rem;"></i>
                  <span>餐馆点餐</span>
                </div>
              </el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 原有的收银页面内容（保留但不显示） -->
    <el-row v-if="false" :gutter="20">
      <el-col :span="14">
        <el-card class="ibox">
          <div slot="header" class="flex justify-between">
            <span>购买商品</span>
            <div>
              <el-button-group>
                <el-button size="small" type="primary" @click="clearCashier()">清空</el-button>
                <el-input v-model="goodCashierInfo.conditions.searchValue" placeholder="请输入条形码/商品名称/条形码后4位"
                  style="width: 300px; margin-right: 10px;" @keyup.enter.native="_loadProduct()"></el-input>
                <el-button size="small" @click="_ListUpStoreOrder()">挂单记录</el-button>
                <el-button size="small" @click="_UpStoreOrder()">挂单</el-button>
              </el-button-group>
            </div>
          </div>
          <el-table :data="goodCashierInfo.productStocks" style="width: 100%;height: 420px;" border stripe>
            <el-table-column prop="prodName" label="商品信息" align="center"></el-table-column>
            <el-table-column label="商品图片" align="center">
              <template slot-scope="scope">
                <img :src="scope.row.coverPhoto" style="width: 60px; height: 60px; border-radius: 5px;">
              </template>
            </el-table-column>
            <el-table-column prop="specName" label="商品规格" align="center"></el-table-column>
            <el-table-column prop="prodPrice" label="单价(元)" align="center">
              <template slot-scope="scope">
                {{ scope.row.prodPrice }}{{ scope.row.cateType == "3" ? "积分" : "" }}
              </template>
            </el-table-column>
            <el-table-column prop="vipPrice" label="会员价(元)" align="center"></el-table-column>
            <el-table-column prop="count" label="数量" align="center"></el-table-column>
            <el-table-column prop="discountPrice" label="优惠(元)" align="center"></el-table-column>
            <el-table-column prop="money" label="小计(元)" align="center">
              <template slot-scope="scope">
                {{ scope.row.money }}{{ scope.row.cateType == "3" ? "积分" : "" }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button size="mini" @click="_openDeleteProductStockModel(scope.row)">取消</el-button>
              </template>
            </el-table-column>
          </el-table>


        </el-card>
        <el-card class="margin-top">
          <div slot="header" class="flex justify-between">
            <span>支付信息</span>
          </div>
          <el-form label-width="100px">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="会员电话：">
                  <el-input v-model="goodCashierInfo.vipUser.vipTel" placeholder="请输入会员电话"
                    @keyup.enter.native="_loadVipUser()">
                    <el-button slot="append" @click="_loadVipUser()">查询</el-button>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="会员名称：">
                  <span>{{ goodCashierInfo.vipUser.vipName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="会员性别：">
                  <span>{{ goodCashierInfo.vipUser.sex == '0' ? '女' : '男' }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="会员等级：">
                  <span>{{ goodCashierInfo.vipUser.levelName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="购物券：">
                  <span>{{ goodCashierInfo.vipUser.couponCount }} 张</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="积分：">
                  <span>{{ goodCashierInfo.vipUser.integralAmount }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="4" class="text-center">
                <div>赠送优惠卷：</div>
                <div style="font-size: 25px;">{{ goodCashierInfo.goldCount }}</div>
              </el-col>
              <el-col :span="4" class="text-center">
                <div>赠送积分：</div>
                <div style="font-size: 25px;">{{ goodCashierInfo.integralCount }}</div>
              </el-col>
              <el-col :span="4" class="text-center">
                <div>消费积分：</div>
                <div style="font-size: 25px;color: red;">{{ goodCashierInfo.bonusPoints }}</div>
              </el-col>
              <el-col :span="4" class="text-center">
                <div>消费金额：</div>
                <div style="font-size: 25px;color: red;">￥{{ goodCashierInfo.money }}</div>
              </el-col>
              <el-col :span="4">
                <el-button type="warning" size="large" @click="_confirmPayCarsh()" style="width: 100%;">结算</el-button>
              </el-col>
              <el-col :span="4">
                <el-button type="primary" size="large" @click="_payWxCarsh()" style="width: 100%;">微信结算</el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </el-col>
      <el-col :span="10">
        <good-cashier-category ref="goodCashierCategory"></good-cashier-category>
      </el-col>
    </el-row>

    <delete-product-stock ref="deleteProductStock"></delete-product-stock>
    <good-cashier-confirm ref="goodCashierConfirm"></good-cashier-confirm>
    <choose-product ref="chooseProduct"></choose-product>
    <edit-product-num ref="editProductNum"></edit-product-num>

    <div v-show="goodCashierInfo.componentShow == 'storeOrderUpManage'">
      <store-order-up-manage ref="storeOrderUpManage"></store-order-up-manage>
    </div>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import GoodCashierCategory from '@/components/goods/goodCashierCategory/goodCashierCategory'
import DeleteProductStock from '@/components/goods/deleteProductStock/deleteProductStock'
import GoodCashierConfirm from '@/components/goods/goodCashierConfirm/goodCashierConfirm'
import ChooseProduct from '@/components/goods/chooseProduct/chooseProduct'
//import EditProductNum from '@/components/goods/editProductNum/editProductNum'
import StoreOrderUpManage from '@/components/goods/storeOrderUpManage/storeOrderUpManage'

export default {
  name: 'GoodCashier',
  components: {
    GoodCashierCategory,
    DeleteProductStock,
    GoodCashierConfirm,
    ChooseProduct,
    // EditProductNum,
    StoreOrderUpManage
  },
  data() {
    return {
      givechange: 0.0,
      discount: 100.0,
      receivable: 0.0,
      goodCashierInfo: {
        lastmoney: 0.0,
        productStocks: [],
        curCatelogId: '',
        total: 0,
        records: 1,
        moreCondition: false,
        barCode: '',
        prodName: '',
        money: 0.0,
        vipPrice: 0.0,
        bonusPoints: 0.0,
        goldCount: 0.0,
        integralCount: 0.0,
        authCode: '',
        prodNameLike: '',
        componentShow: 'goodCashierInfo',
        storeOrderUp: {
          vipId: '',
          totalPrice: '',
          state: '',
          shopId: '',
          orderUpId: '',
        },
        vipUser: {
          vipUserSearchValue: '',
          vipName: '',
          vipTel: '',
          levelName: '',
          sex: '',
          integralAmount: '0',
          vipId: '',
          couponCount: '0'
        },
        conditions: {
          searchValue: '',
          page: 1,
          row: 1,
          shopId: getShopId()
        }
      }
    }
  },
  methods: {
    goToGoodsCashier() {
      const routeData = this.$router.resolve({ path: '/pages/pos/goodsPos' })
      window.open(routeData.href, '_blank')
    },
    showRestaurantMessage() {
      const routeData = this.$router.resolve({ path: '/pages/pos/mealPos' })
      window.open(routeData.href, '_blank')
    },
    _initData() {
      this.$nextTick(() => {
        if (document.getElementById("searchValue")) {
          document.getElementById("searchValue").focus()
        }
      })
    },
    _loadProduct() {
      // API调用实现
    },
    _editProductNum(stock) {
      this.$refs.editProductNum.open({ stock })
    },
    _computeCashierMoney() {
      // 计算逻辑实现
    },
    _dealProduct(product) {
      console.log(product)
      // 处理商品逻辑
    },
    _hasExistsProduct(product) {
      console.log(product)
      // 检查商品是否存在
    },
    _openDeleteProductStockModel(product) {
      this.$refs.deleteProductStock.open(product)
    },
    _computeVipUserGold() {
      // 计算会员积分逻辑
    },
    _queryStoreOrderCartUp(storeOrderUps) {
      console.log(storeOrderUps)
      // 查询挂单商品逻辑
    },
    _updateStoreOrderCartUp() {
      // 更新挂单商品逻辑
    },
    _payWxCarsh() {
      this.$refs.goodCashierConfirm.openWxCarsh(this.goodCashierInfo)
    },
    _confirmPayCarsh() {
      this.$refs.goodCashierConfirm.open(this.goodCashierInfo)
    },
    _loadVipUser() {
      // 加载会员信息逻辑
    },
    clearCashier() {
      // 清空收银台逻辑
    },
    _UpStoreOrder() {
      // 挂单逻辑
    },
    _ListUpStoreOrder() {
      this.goodCashierInfo.componentShow = 'storeOrderUpManage'
      this.$refs.storeOrderUpManage.listStoreOrderUp()
    },
    _getSpecValue(productDetail) {
      console.log(productDetail)
      // 获取规格值逻辑
    },
    _goodCashierEditProductStock(param) {
      console.log(param)
      // 编辑商品数量逻辑
    }
  },
  created() {
    this._initData()
  },
  watch: {
    discount() {
      this.caculateMoney()
    },
    receivable() {
      this.givechangeMoney()
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}

.margin-top {
  margin-top: 20px;
}

.text-center {
  text-align: center;
}
</style>